/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPeopleInfoMarketingContentData_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null };

export type GetPeopleInfoMarketingContentData_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly dsaVersion: string | null, readonly authorizedSigner: GetPeopleInfoMarketingContentData_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetPeopleInfoMarketingContentData_Query = { readonly __typename: 'Query', readonly creditApplication: GetPeopleInfoMarketingContentData_creditApplication_CreditApplication | null };


export type GetPeopleInfoMarketingContentDataVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetPeopleInfoMarketingContentData = GetPeopleInfoMarketingContentData_Query;


export const GetPeopleInfoMarketingContentDataDocument = gql`
    query GetPeopleInfoMarketingContentData($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    dsaVersion
    authorizedSigner {
      id
      email
    }
  }
}
    `;

/**
 * __useGetPeopleInfoMarketingContentData__
 *
 * To run a query within a React component, call `useGetPeopleInfoMarketingContentData` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleInfoMarketingContentData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleInfoMarketingContentData({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetPeopleInfoMarketingContentData(baseOptions: Apollo.QueryHookOptions<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables> & ({ variables: GetPeopleInfoMarketingContentDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>(GetPeopleInfoMarketingContentDataDocument, options);
      }
export function useGetPeopleInfoMarketingContentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>(GetPeopleInfoMarketingContentDataDocument, options);
        }
export function useGetPeopleInfoMarketingContentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>(GetPeopleInfoMarketingContentDataDocument, options);
        }
export type GetPeopleInfoMarketingContentDataHookResult = ReturnType<typeof useGetPeopleInfoMarketingContentData>;
export type GetPeopleInfoMarketingContentDataLazyQueryHookResult = ReturnType<typeof useGetPeopleInfoMarketingContentDataLazyQuery>;
export type GetPeopleInfoMarketingContentDataSuspenseQueryHookResult = ReturnType<typeof useGetPeopleInfoMarketingContentDataSuspenseQuery>;
export type GetPeopleInfoMarketingContentDataQueryResult = Apollo.QueryResult<GetPeopleInfoMarketingContentData, GetPeopleInfoMarketingContentDataVariables>;